import { rate_limit_percentage } from '@shared/constants';

export const progressColor = {
  green: '#34d399',
  yellow: '#FBBF24',
  red: '#F87171',
};

export function getStrokeColor(percent: number): 'green' | 'yellow' | 'red' {
  if (percent <= rate_limit_percentage.green) return 'green';
  if (percent <= rate_limit_percentage.yellow) return 'yellow';
  return 'red';
}
